import { Component, OnInit } from '@angular/core';
import { MatterLRO } from '@models/matter';
import { LRO } from '@models/lro';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { MatterActions } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { Observable } from 'rxjs';
import { TestHooks } from './suggestion.hooks';

@UntilDestroy()
@Component({
	selector: 'app-lro-suggestions',
	templateUrl: './suggestion.component.html',
	standalone: false,
})
export class LROSuggestionComponent implements OnInit {
	testHooks = TestHooks;
	public filteredSuggestedLROs: LRO[] = [];

	@Select(SelectedMatter.LRO) LRO$: Observable<MatterLRO>;
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	ngOnInit(): void {
		this.LRO$.pipe(untilDestroyed(this)).subscribe((value) => {
			this.filteredSuggestedLROs = value?.suggested?.filter(
				(lro) => lro.id !== value?.selected?.id,
			);
		});
	}

	@Dispatch()
	_setLRO(_matterId: string, lro: LRO): MatterActions.SetLRO {
		return new MatterActions.SetLRO({ matterId: _matterId, lro });
	}

	setLRO(lro) {
		this._setLRO(this.matterId, lro);
	}
}
